import React, { useState, useEffect } from "react";
import Link from "next/link";
import ReactTooltip from "react-tooltip";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// glossary component with title and description
export var GlossaryList = _ref => {
  var {
    title,
    description,
    slug
  } = _ref;
  var [isMounted, setIsMounted] = useState(false); // Need this for the react-tooltip

  useEffect(() => {
    setIsMounted(true);
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    "data-tip": true,
    "data-for": slug,
    className: "h-full bg-white shadow overflow-hidden sm:rounded-lg px-0 py-0 mb-2 cursor-pointer list-item list-item-" + title.charAt(0).toLowerCase(),
    children: [/*#__PURE__*/_jsx(Link, {
      href: "/glossary/" + slug,
      children: /*#__PURE__*/_jsx("div", {
        className: "block px-4 py-3 sm:px-6 hover:bg-slate-600",
        children: /*#__PURE__*/_jsx("span", {
          className: "text-lg font-medium",
          children: title
        })
      })
    }), isMounted && /*#__PURE__*/_jsx(ReactTooltip, {
      id: slug,
      place: "top",
      multiline: true,
      children: /*#__PURE__*/_jsx("div", {
        className: "text-xs max-w-sm",
        children: description
      })
    })]
  });
};
export var GlossaryNav = _ref2 => {
  var {
    data
  } = _ref2;
  // convert glossary to an array of objects with the first letter of each word
  var nav = data ? data.reduce((acc, item, index) => {
    var firstLetter = item.title.charAt(0).toLowerCase();

    if (!acc[firstLetter]) {
      acc[firstLetter] = [];
    }

    acc[firstLetter].push({
      item: index
    });
    return acc;
  }, {}) : {}; // make a list of letters

  var letters = Object.keys(nav); // show or hide the elements based on the letter selected

  var handleClick = (letter, event) => {
    event.preventDefault();
    var listElements = document.querySelectorAll(".list-item");

    if (letter === "all") {
      listElements.forEach(element => {
        element.classList.remove("hidden");
      });
    } else {
      listElements.forEach(element => {
        element.classList.add("hidden");
      });
      var selectedListElements = document.querySelectorAll(".list-item-" + letter);
      selectedListElements.forEach(element => {
        element.classList.remove("hidden");
      });
    }

    var navElements = document.querySelectorAll(".glossary-nav-item");
    navElements.forEach(element => {
      element.classList.remove("!text-tertiary");
      element.classList.remove("!bg-tertiary");
    });
    event.target.classList.add("!text-tertiary");
    event.target.classList.add("!bg-tertiary");
  };

  var navItems = letters.map((letter, index) => {
    return /*#__PURE__*/_jsx("li", {
      className: "block w-full cursor-pointer align-middle relative",
      children: /*#__PURE__*/_jsxs("a", {
        onClick: event => handleClick(letter, event),
        href: "#" + index,
        "data-for": "" + index,
        "data-tip": true,
        className: ["block p-1 md:p-2 w-full text-center glossary-nav-item", index === 10 ? "rounded-tr-lg md:rounded-tr-none" : null, index === letters.length - 12 ? "rounded-bl-lg md:rounded-bl-none" : null, index === letters.length - 1 ? "rounded-br-lg md:rounded-br-none" : null].join(" "),
        children: [letter.toUpperCase(), /*#__PURE__*/_jsxs("div", {
          role: "tooltip",
          className: "tooltip pointer-events-none mx-4 md:mx-0 inset-x-2 -top-3 hidden absolute z-0 text-sm font-medium text-white bg-grey-900 rounded-lg shadow-sm opacity-0 transition-opacity duration-300 bg-grey-700",
          children: [nav[letter].length, /*#__PURE__*/_jsx("div", {
            className: "tooltip-arrow",
            "data-popper-arrow": true
          })]
        })]
      })
    }, letter + "-" + index);
  });
  return /*#__PURE__*/_jsxs("ul", {
    className: "w-full grid grid-cols-12 md:flex md:flex-nowrap bg-white text-base rounded-lg shadow-lg md:divide-x divide-grey-300/30 md:pb-2 mb-6",
    children: [/*#__PURE__*/_jsx("li", {
      className: "block w-full cursor-pointer align-middle relative",
      children: /*#__PURE__*/_jsx("a", {
        onClick: event => handleClick("all", event),
        className: "block p-1 md:p-2 w-full text-center glossary-nav-item !text-tertiary !bg-tertiary rounded-tl-lg md:rounded-tl-none",
        children: "All"
      })
    }), navItems]
  });
};
export var Glossary = _ref3 => {
  var {
    data
  } = _ref3;
  if (!data) return /*#__PURE__*/_jsx("div", {
    children: "No glossary items"
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "w-full",
    children: [/*#__PURE__*/_jsx(GlossaryNav, {
      data: data
    }), /*#__PURE__*/_jsx("div", {
      className: "grid grid-cols-1 md:grid-cols-3 gap-4",
      children: data.map((item, index) => {
        return /*#__PURE__*/_jsx(GlossaryList, {
          title: item.title,
          description: item.description,
          slug: item.slug
        }, item.uuid + "-" + index);
      })
    })]
  });
};
//# sourceMappingURL=glossary.js.map